import React from 'react';
import PropTypes from 'prop-types';
import './Icon.css';

const Icon = ({ active, icon, badgeNumber, rotate, dataId }) => (
  <span className={`icon ${rotate > 0 ? `icon--rotate-${rotate}` : ''}`}>
    <i
      data-id={dataId}
      className={`material-icons ${active ? 'icon--active' : ''}`}
    >
      {icon}
    </i>
    {badgeNumber !== undefined && (
      <span className="icon__badge">{badgeNumber}</span>
    )}
  </span>
);

const validRotates = Array(360 / 45 + 1)
  .fill('')
  .map((a, i) => i * 45);

Icon.propTypes = {
  rotate: PropTypes.oneOf(validRotates),
  active: PropTypes.bool,
  style: PropTypes.shape({}),
  icon: PropTypes.string,
  badgeNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataId: PropTypes.number,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.jsx